import React, { forwardRef } from 'react'
import { GridItemProps } from './Grid.types'
import { StyledGridItem } from './Grid.styles'

const GridItem = forwardRef<HTMLDivElement, GridItemProps>(
  ({ children, ...props }, ref) => {
    return (
      <StyledGridItem ref={ref} {...props}>
        {children}
      </StyledGridItem>
    )
  }
)

GridItem.displayName = 'GridItem'

export default GridItem
